import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
@Component({
  selector: 'app-prompt-modal',
  templateUrl: './prompt-modal.component.html',
  styleUrls: ['./prompt-modal.component.scss']
})
export class PromptModalComponent implements OnInit {
  modalHeader: string;
  modalContent: string;
  modalValue: any[] = [];
  showAddButton: boolean = false;
  target;
  @ViewChild('myInput') input: ElementRef;
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private renderer: Renderer
  ) { }

  ngOnInit() {
    if (this.modalValue.length == 0)
      this.modalValue.push({ value: '' });
  }

  closeModal() {
    this.activeModal.close();
    return false;
  }
  successModal() {
    console.log("clicked on ok");
    this.activeModal.close();
  }

  cancelModal() {
    console.log("clicked on abort");
    this.activeModal.close();
  }
  ngAfterViewInit() {
    this.renderer.invokeElementMethod(this.input.nativeElement, 'focus');
  }

  appendInput() {
    this.modalValue.push({ value: '' });
    //this.renderer.invokeElementMethod(this.input.nativeElement, 'focus');
  }
  discardInput(index) {
    this.modalValue.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/prompt-modal/prompt-modal.component.ts